
import React, { Component } from 'react';
import { Modal, Row, Divider, Button, Table} from 'antd';
import http from '../../../axios/http';

class AuctionLotsDetail extends Component {
    columns = [{
        title: '车架号',
        dataIndex: 'vin',
        width: '15%',
    }, {
        title: '账期内天数',
        dataIndex: 'dayNumber',
        width: '8%',
    }
    , {
        title: '开始时间',
        dataIndex: 'startDateStr',
        width: '10%',
    }
    , {
        title: '结束时间',
        dataIndex: 'endDateStr',
        width: '10%',
    }
    , {
        title: '凑5天',
        dataIndex: 'gatherFive',
        width: '5%',
        format: { 0: "是", 1: "否" }
    }
    , {
        title: '凑10天',
        dataIndex: 'gatherTen',
        width: '5%',
        format: { "true": "是", "false": "否" }
    }
    , {
        title: '凑15天',
        dataIndex: 'gatherFifteen',
        width: '5%',
        format: { "true": "是", "false": "否" }
    }
    , {
        title: '凑20天',
        dataIndex: 'gatherTwenty',
        width: '5%',
        format: { "true": "是", "false": "否" }
    }
    , {
        title: '凑25天',
        dataIndex: 'gatherTwentyfive',
        width: '5%',
        format: { "true": "是", "false": "否" }
    }
    , {
        title: '凑30天',
        dataIndex: 'gatherThirty',
        width: '5%',
        format: { "true": "是", "false": "否" }
    }

];
    exportExcel = () => {
        const { billId }=this.props;
        http.download({
        url: "/barrier/batchVehicleBillDetail/excel",
        data: { billId },
        fileName: `账单明细.xlsx`,
        });
    };
    render() {
        const { visible, onCancel} = this.props;
        return (
            <Modal
                width={1000}
                visible={visible}
                title="账单详情"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                footer={[
                    <Button key="take" type="primary" onClick={this.exportExcel}>导出</Button>,
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>
                ]}
            >
                <Row>
                    <Divider orientation="left">账单详情列表</Divider>
                    <Table
                        rowKey="id"
                        columns={this.columns}
                        dataSource={this.props.billDetails}
                        pagination={{ pageSize: 10 }}
                        bordered={true}
                    />
                </Row>
            </Modal>
        );
    }
}


export default AuctionLotsDetail;